import { useNavigate } from "react-router-dom";

import { FinanceOverviewWorkbenchFeaturePage } from "..";

/** 财务工作台页面：点卡片、待办进对应的页面，地址上带好筛选（那几页以地址为准）。 */
export function FinanceWorkbenchPage() {
  const navigate = useNavigate();
  return <FinanceOverviewWorkbenchFeaturePage onNavigate={(path) => navigate(path)} />;
}
